/* jshint esversion: 6, -W097 */
/* globals require */
'use strict';

/**
 * @module enervee_utils.callout_button
 */
function buttonDirective() {
    return {
        // must be an element (can not be used as an attribute or ...)
        restrict: 'E',
        replace: true,
        scope: {
            params: '<'
        },
        template: require('./calloutButtonView.html')
    };
}

module.exports = buttonDirective;
